export const CONFIG = {
    client_name : "hornbach-at",
    client_display_name : "Hornbach",
    modal_confirm_button_label : "übernehmen",
    country : 'de',
    base_asset_url : `https://esr.fe-bis.de/at/hornbach/`,
    plz_validation : (plz : string) => plz.length == 4,
    plz_default: "1234",
    foerderung : false,
    show_funding_list: false,
    development_mode: false,
}